/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { StoreGroupDetailsResponse } from '../../models/store-group-details-response';

export interface GetAllStoreGroups$Params {
  'Active-Tenant-Identifier': string;
}

export function getAllStoreGroups(http: HttpClient, rootUrl: string, params: GetAllStoreGroups$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<StoreGroupDetailsResponse>>> {
  const rb = new RequestBuilder(rootUrl, getAllStoreGroups.PATH, 'get');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<StoreGroupDetailsResponse>>;
    })
  );
}

getAllStoreGroups.PATH = '/store-groups';
